import PropTypes from 'prop-types'
import cn from 'classnames'

import { ReactComponent as IconShift4Logo } from 'assets/icons/IconShift4Logo.svg'

const Loader = ({ container, center }) => (
  <div
    className={cn('loader', {
      '-center': center,
      '-container': container
    })}
  >
    <div className="loader__wrapper">
      <IconShift4Logo className="loader__logo" />
      <div className="loader__circle" />
      <div className="loader__mask" />
    </div>
  </div>
)

Loader.defaultProps = {
  center: true,
  container: true
}

Loader.propTypes = {
  center: PropTypes.bool,
  container: PropTypes.bool
}

export default Loader
